import * as d3 from 'd3'
export default {

  methods: {

    draw_Legend() {

      let legend = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.header.x+.5}, 120.5)`)

      let x_ = 0
      this.legends.forEach((d,i)=> {
        legend
        .append('rect')
        .attr('x', x_).attr('y', -4)
        .attr('width', 9).attr('height', 9).attr('fill', d.color).attr('opacity', .5)

        legend
        .append('text')
        .attr('id', `LEGEND_${i}`)
        .attr('x', x_+13).attr('y', 11*0.35)
        .attr('fill', '#333').attr('font-size', 11)
        .text(`${d.name} (${d.count})`)

        x_ = x_ + this.getNode(`#LEGEND_${i}`,'width') + 30
      })


      this.canvasForms
      .append('image')
      .attr('xlink:href', this.HOST + '/Procurement/Legend_RFQ.svg')
      .attr('x', this.timeline.x+.5).attr('y', 82).attr('width', 180)
    },
  }
}